<template>
  <div class="artist">

     <!-- On Big Screens -->
     <v-toolbar app clipped-left :hidden="$vuetify.breakpoint.smAndDown">
          <v-toolbar-side-icon @click.stop="toggleMenu=!toggleMenu"></v-toolbar-side-icon>
          <img src="../../../static/images/smartkidsmarket-logo.svg" style="height:60px; cursor:pointer" />
          <v-toolbar-title> Parent Portal</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat @click="logout">Logout</v-btn>
          </v-toolbar-items>
     </v-toolbar>

     <!-- On Little Screens -->
     <v-toolbar app clipped-left :hidden="$vuetify.breakpoint.mdAndUp" >
         <v-toolbar-side-icon @click.stop="toggleMenu=!toggleMenu"></v-toolbar-side-icon>
         <v-menu offset-y bottom  >
           <v-toolbar-title slot="activator">
               Parent Portal
               <v-icon class="ml-1">{{ $vuetify.icons.down }}</v-icon>

           </v-toolbar-title>

           <v-list-tile style="background:white">

           </v-list-tile>
           <v-list-tile style="background:white">
               <v-btn flat @click="logout" >Logout</v-btn>
           </v-list-tile>
         </v-menu>
    </v-toolbar>

     <v-navigation-drawer
              fixed
              app
              :clipped="$vuetify.breakpoint.lgAndUp"
              v-model="toggleMenu">
             <v-list>
               <template v-for="item in kids">
                 <v-list-tile  :key="item.id" v-on:click="gotoKid(item)" to="/parents/">
                   <v-list-tile-action><v-icon>{{$vuetify.icons.kid}}</v-icon></v-list-tile-action>
                   <v-list-tile-title>{{item.name}}</v-list-tile-title>
                 </v-list-tile>
               </template>

               <v-divider></v-divider>
               <v-list-tile key="Profile" @click="gotoProfile()" to="/parents/profile/">
                 <v-list-tile-action>
                   <v-icon>{{$vuetify.icons.settings}}</v-icon>
                 </v-list-tile-action>

                 <v-list-tile-content>
                   <v-list-tile-title>Profile</v-list-tile-title>
                 </v-list-tile-content>
               </v-list-tile>
             </v-list>
           </v-navigation-drawer>

           <v-content>
             <v-container fluid>
               <router-view>
               </router-view>
             </v-container>
           </v-content>

</div>

</template>

<script>
import firebase from 'firebase/app'
import {mapState} from 'vuex'
import KidMenu2 from './KidMenu2.vue'

export default {
  name: 'ParentPortal',
  components: {
    KidMenu2
  },
  props: {

  },
  computed: {
    ...mapState({
      name: state => state.admin.userInfo.name,
      uid: state => state.parent.uid,
      kids: state => state.parent.kidsInfo,
      unsubAuth: state => state.parent.unsubAuth,
      kidSelected: state => state.parent.kidSelected
    })
  },
  data () {
    return {
      toggleMenu: true
    }
  },
  watch: {
  },
  mounted: function () {
    // Now load the artists info
    this.$store.dispatch('parent/loadCurrentParent')

    if (this.unsubAuth) {
      // console.log("UNSUBSCRIBED from Auth event in PPortal")
      this.unsubAuth()
    }
    // Auth change, load current parent
    const unsub = firebase.auth().onAuthStateChanged(() => {
      const currentUser =  firebase.auth().currentUser

      if (currentUser) {
        // console.log('AUTH CHANGE PPortal User is now:' + firebase.auth().currentUser.uid)
        // Set it in the store
        this.$store.dispatch('parent/loadCurrentParent')
      } else {
        // console.log('AUTH CHANGE PPortal User is now: NULL')
        this.$store.dispatch('parent/loadCurrentParent')
      }
    })
    // console.log("SUBSCRIBED to Auth event in PPortal")
    this.$store.commit('parent/setUnsubAuth', unsub)
  },
  methods: {
    logout: function () {
      console.log("DEBUG: signout in PPortal")
      firebase.auth().signOut().then(() => {
        this.$router.replace('/login')
      })
    },
    gotoKid: function (kid) {
      this.$router.push({path: '/parents/'})
      this.$store.commit('parent/setKidSelected', kid)
    },
    gotoProfile: function () {
      this.$router.push({path: '/parents/profile/'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
